import Link from 'next/link'
import { useRouter } from 'next/router'

import { Language } from '@nxt-insurance/constants'
import { body2 } from '@nxt-insurance/ui-kit/core/typography'

import { EVENTS, LINKS_IDS } from '@/constants/analytics'
import { useAnalytics } from '@/context/AnalyticsContext'
import type { AlternateLink } from '@/hooks/useAlternateLinks'
import { getLocaleParts } from '@/utils/locale'
import { useQuery } from '@tanstack/react-query'
import TopBar from '@ui-kit/components/Bars/TopBar'
import Spacer from '@ui-kit/components/layoutComponents/Spacer'

export const SwitchToEnglishSection = (props: { alternateLinks: AlternateLink[] }) => {
  const { track } = useAnalytics()
  const { locale, locales } = useRouter()
  const [lang, market] = getLocaleParts(locale)
  const { data: userLanguage, isFetching: isFetchingUserLanguage } = useQuery({
    queryKey: ['userLanguage'],
    queryFn: async () => {
      const res = await fetch('/api/language')
      const userLanguageJSON = await res.json()
      if (
        userLanguageJSON.language === null ||
        !locales?.includes(`${userLanguageJSON.language}-${market}`)
      ) {
        return 'en'
      }
      return userLanguageJSON.language
    },
  })
  const newLocale = `en-${market}`
  const href = props.alternateLinks
    .find((link) => link.hrefLang === newLocale)
    ?.href.split(newLocale)[1]

  // we want to display the banner for pages in English and when the browser language is english
  if (lang === Language.En || isFetchingUserLanguage || userLanguage !== 'en') {
    return null
  }

  return (
    <div className={'flex w-full flex-col lg:hidden'}>
      <Link
        href={href ?? '/'}
        locale={newLocale}
        onClick={() => {
          track(EVENTS.LinkClicked, {
            buttonId: LINKS_IDS.SWITCH_TO_ENGLISH,
          })
        }}
      >
        <TopBar
          bgColor="brandLime"
          content={
            <>
              <span className={body2()}> Don&apos;t understand a thing?</span>{' '}
              <Spacer horizontal size="xxsmall" />
              <span className={body2({ className: 'underline' })}>Switch to English </span>
            </>
          }
        />
      </Link>
    </div>
  )
}
